import { Injectable, Output, EventEmitter  } from '@angular/core';
import { Observable, BehaviorSubject} from 'rxjs';

import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { ResponseInterface } from 'src/app/core/interfaces/response-interface';

import { VehicleDisplay, showVehicleButton } from 'src/app/shared/models/configuration';
@Injectable({
  providedIn: 'root'
})
export class VehicleConfigService {

  @Output() displayOn = new EventEmitter<any>();
  @Output() updateName = new EventEmitter<any>();

  public applyViewConfig = false;

  public configuration : any = {
    panel : {
      showIconsTransmision : true,
      btnCreateGroup : true,
      btnCustomPanel : true
    },
    view : {
      showOnMap : {
        visible : true,
        enabled : true,
      },
      showByOperation : {
        visible : true,
        enabled : true,
      },
      showOnlyVisible : {
        visible : true,
        enabled : true,
      },
    }
  }

  // Observable para suscribirse
  public vehicleDisplaySubject = new BehaviorSubject<VehicleDisplay>({
    showOnMap: {
      enabled: true,
      visible: true
    },
    showByOperation: {
      enabled: true,
      visible: true
    },
    showOnlyVisible: {
      enabled: true,
      visible: true
    }
  });
  public vehicleDisplay$ = this.vehicleDisplaySubject.asObservable();
  
  // iconos de tranmision
  public showIconTransmissionSubject = new BehaviorSubject<boolean>(true);
  public showIconTransmission$ = this.showIconTransmissionSubject.asObservable();
  


  public stateOptionsButtons: { label: string; value: number }[] = [
    {
      label: "Placa",
      value: 3,
    },
    {
      label: "Código Interno",
      value: 2,
    },
    {
      label: "Nombre",
      value: 1,
    },
  ];
  // mostrar stados por
  public valueSelectButtonSubject = new BehaviorSubject<showVehicleButton>(
    {
      selected : 1,
      showOptions : true
    }
  );
  public valueSelectButton$ = this.valueSelectButtonSubject.asObservable();

  constructor(private http: HttpClient) { }

  // private URL_LIST = 'http://127.0.0.1:8001/api/tracker';
  private api_url = environment.apiUrl;

  public getTest(){
    // //console.log("apiurl = ",this.api_url);
    return this.http.get(this.api_url+"/api/test");
  }
  public onVehicleUpdate(vehicle:any): void{
    this.updateName.emit(vehicle);
  }

  public setVehicleDisplayConfig() {
    if (!this.configuration || !this.configuration.view) {
      console.warn('⚠️ No existe configuración o propiedad "view" en la configuración:', this.configuration);
      return;
    }
    let {showOnMap, showByOperation, showOnlyVisible} = this.configuration.view;

    const hasValidFields =
      showOnMap?.visible !== undefined &&
      showByOperation?.visible !== undefined &&
      showOnlyVisible?.visible !== undefined;

    if (!hasValidFields) {
      console.warn('Campos visibles no válidos en la configuración:', this.configuration.view);
      return;
    }


    if(!showOnMap.visible && !showByOperation.visible && !showOnlyVisible.visible){
    document.documentElement.style.setProperty(
        '--container-vehicle-display-height',
        '70px'
      );
    }else {
      document.documentElement.style.setProperty(
        '--container-vehicle-display-height',
        '0px'
      );
    }
  }

  public setShowIconTransmission() {
    if (
      !this.configuration ||
      !this.configuration.panel ||
      typeof this.configuration.panel !== 'object'
    ) {
      console.warn('Configuración del panel inválida o no encontrada:', this.configuration);
      return;
    }
    let {showIconsTransmision} = this.configuration.panel
    if(!showIconsTransmision){
      document.documentElement.style.setProperty(
        '--container-transmission-height',
        '70px'
      );
    }else {
      document.documentElement.style.setProperty(
        '--container-transmission-height',
        '0px'
      );
    }
  }

  public setSelectedButton(selected : showVehicleButton) {
    this.valueSelectButtonSubject.next(selected)
  }

  putConfig(vehicle: any): Observable<any>{
    return this.http.put(this.api_url+"/api/tracker/"+vehicle.IMEI,vehicle);
  }
  postGroup(req: any): Observable<any>{
    return this.http.post(this.api_url+"/api/group",req);
  }
  putGroupDelete(req: any): Observable<any>{
    return this.http.put(this.api_url+"/api/group_delete",req);
  }
  putGroupUpdate(req: any): Observable<any>{
    return this.http.put(this.api_url+"/api/group_update",req);
  }

  public async updateUnitFixes(subuser: any) {
    const response:ResponseInterface = await this.http.post<ResponseInterface>(`${environment.apiUrl}/api/updateVehiclesFixes`,subuser).toPromise();
    // console.log(response);
    return response;
  }

  public async cleanUnitFixes(subuser: any) {
    const response:ResponseInterface = await this.http.post<ResponseInterface>(`${environment.apiUrl}/api/cleanVehiclesFixes`,subuser).toPromise();
    // console.log(response);
    return response;
  }

  putVehicleFollow(vehicleFollow: any): Observable<any>{
    return this.http.post(this.api_url+"/api/follow_store",vehicleFollow);
  }


}
